import { IntegrationScript } from "src/integrations/lib/IntegrationScript"

const src = "https://1613880315.elvent.shop/javascript/script.js"

export const KlarTag = () => {
  return <IntegrationScript id="klar" src={src} />
}
